import { EComponentStack } from "@app/state/constants";
import { TBlueObj } from "@app/types/insider";

export const intitialUiAllotment = {
  [EComponentStack.InvoiceTracking]: [null, null],
  [EComponentStack.InvoicingInKarma]: [null, null],
  [EComponentStack.InvoiceOverall]: [null, null],
  [EComponentStack.SpvMessages]: [null, null],
};

export const initialAllotmentCollapsed = {
  [EComponentStack.InvoiceTracking]: false,
  [EComponentStack.InvoicingInKarma]: false,
  [EComponentStack.InvoiceOverall]: false,
  [EComponentStack.SpvMessages]: false,
};
type TUiAllotment = typeof intitialUiAllotment;

export const uiAllotment: TBlueObj<TUiAllotment> = {
  name: "uiAllotment",
  initialState: intitialUiAllotment,
  starfx: true,
  idb: false,
  bootPriority: 2,
};

export const uiAllotmentCollapsed: TBlueObj<typeof initialAllotmentCollapsed> =
  {
    name: "uiAllotmentCollapsed",
    initialState: initialAllotmentCollapsed,
    starfx: true,
    idb: false,
    bootPriority: 2,
  };
